"use strict";
import { __exports as f } from "./index.es482.js";
var _;
function g() {
  return _ ? f : (_ = 1, (function(m) {
    Object.defineProperty(m, "__esModule", {
      value: !0
    });
    function E(o, t) {
      for (var n in t) Object.defineProperty(o, n, {
        enumerable: !0,
        get: t[n]
      });
    }
    E(m, {
      getSortedRouteObjects: function() {
        return R;
      },
      getSortedRoutes: function() {
        return d;
      }
    });
    class l {
      insert(t) {
        this._insert(t.split("/").filter(Boolean), [], !1);
      }
      smoosh() {
        return this._smoosh();
      }
      _smoosh(t) {
        t === void 0 && (t = "/");
        const n = [
          ...this.children.keys()
        ].sort();
        this.slugName !== null && n.splice(n.indexOf("[]"), 1), this.restSlugName !== null && n.splice(n.indexOf("[...]"), 1), this.optionalRestSlugName !== null && n.splice(n.indexOf("[[...]]"), 1);
        const s = n.map((r) => this.children.get(r)._smoosh("" + t + r + "/")).reduce((r, e) => [
          ...r,
          ...e
        ], []);
        if (this.slugName !== null && s.push(...this.children.get("[]")._smoosh(t + "[" + this.slugName + "]/")), !this.placeholder) {
          const r = t === "/" ? "/" : t.slice(0, -1);
          if (this.optionalRestSlugName != null)
            throw Object.defineProperty(new Error('You cannot define a route with the same specificity as a optional catch-all route ("' + r + '" and "' + r + "[[..." + this.optionalRestSlugName + ']]").'), "__NEXT_ERROR_CODE", {
              value: "E458",
              enumerable: !1,
              configurable: !0
            });
          s.unshift(r);
        }
        return this.restSlugName !== null && s.push(...this.children.get("[...]")._smoosh(t + "[..." + this.restSlugName + "]/")), this.optionalRestSlugName !== null && s.push(...this.children.get("[[...]]")._smoosh(t + "[[..." + this.optionalRestSlugName + "]]/")), s;
      }
      _insert(t, n, s) {
        if (t.length === 0) {
          this.placeholder = !1;
          return;
        }
        if (s)
          throw Object.defineProperty(new Error("Catch-all must be the last part of the URL."), "__NEXT_ERROR_CODE", {
            value: "E392",
            enumerable: !1,
            configurable: !0
          });
        let r = t[0];
        if (r.startsWith("[") && r.endsWith("]")) {
          let u = function(h, i) {
            if (h !== null && h !== i)
              throw Object.defineProperty(new Error("You cannot use different slug names for the same dynamic path ('" + h + "' !== '" + i + "')."), "__NEXT_ERROR_CODE", {
                value: "E337",
                enumerable: !1,
                configurable: !0
              });
            n.forEach((c) => {
              if (c === i)
                throw Object.defineProperty(new Error('You cannot have the same slug name "' + i + '" repeat within a single dynamic path'), "__NEXT_ERROR_CODE", {
                  value: "E247",
                  enumerable: !1,
                  configurable: !0
                });
              if (c.replace(/\W/g, "") === r.replace(/\W/g, ""))
                throw Object.defineProperty(new Error('You cannot have the slug names "' + c + '" and "' + i + '" differ only by non-word symbols within a single dynamic path'), "__NEXT_ERROR_CODE", {
                  value: "E499",
                  enumerable: !1,
                  configurable: !0
                });
            }), n.push(i);
          }, e = r.slice(1, -1), a = !1;
          if (e.startsWith("[") && e.endsWith("]") && (e = e.slice(1, -1), a = !0), e.startsWith("…"))
            throw Object.defineProperty(new Error("Detected a three-dot character ('…') at ('" + e + "'). Did you mean ('...')?"), "__NEXT_ERROR_CODE", {
              value: "E147",
              enumerable: !1,
              configurable: !0
            });
          if (e.startsWith("...") && (e = e.substring(3), s = !0), e.startsWith("[") || e.endsWith("]"))
            throw Object.defineProperty(new Error("Segment names may not start or end with extra brackets ('" + e + "')."), "__NEXT_ERROR_CODE", {
              value: "E421",
              enumerable: !1,
              configurable: !0
            });
          if (e.startsWith("."))
            throw Object.defineProperty(new Error("Segment names may not start with erroneous periods ('" + e + "')."), "__NEXT_ERROR_CODE", {
              value: "E288",
              enumerable: !1,
              configurable: !0
            });
          if (s)
            if (a) {
              if (this.restSlugName != null)
                throw Object.defineProperty(new Error('You cannot use both an required and optional catch-all route at the same level ("[...' + this.restSlugName + ']" and "' + t[0] + '" ).'), "__NEXT_ERROR_CODE", {
                  value: "E299",
                  enumerable: !1,
                  configurable: !0
                });
              u(this.optionalRestSlugName, e), this.optionalRestSlugName = e, r = "[[...]]";
            } else {
              if (this.optionalRestSlugName != null)
                throw Object.defineProperty(new Error('You cannot use both an optional and required catch-all route at the same level ("[[...' + this.optionalRestSlugName + ']]" and "' + t[0] + '").'), "__NEXT_ERROR_CODE", {
                  value: "E300",
                  enumerable: !1,
                  configurable: !0
                });
              u(this.restSlugName, e), this.restSlugName = e, r = "[...]";
            }
          else {
            if (a)
              throw Object.defineProperty(new Error('Optional route parameters are not yet supported ("' + t[0] + '").'), "__NEXT_ERROR_CODE", {
                value: "E435",
                enumerable: !1,
                configurable: !0
              });
            u(this.slugName, e), this.slugName = e, r = "[]";
          }
        }
        this.children.has(r) || this.children.set(r, new l()), this.children.get(r)._insert(t.slice(1), n, s);
      }
      constructor() {
        this.placeholder = !0, this.children = /* @__PURE__ */ new Map(), this.slugName = null, this.restSlugName = null, this.optionalRestSlugName = null;
      }
    }
    function d(o) {
      const t = new l();
      return o.forEach((n) => t.insert(n)), t.smoosh();
    }
    function R(o, t) {
      const n = {}, s = [];
      for (let e = 0; e < o.length; e++) {
        const a = t(o[e]);
        n[a] = e, s[e] = a;
      }
      return d(s).map((e) => o[n[e]]);
    }
  })(f), f);
}
export {
  g as __require
};
//# sourceMappingURL=index.es447.js.map
